import React from 'react';
import BusinessCenterRoundedIcon from '@mui/icons-material/BusinessCenterRounded';
import { useTheme } from '@mui/material/styles';
import { Stack } from '../material';

const EmptyOpportunityImage: React.FC = () => {
  const { palette } = useTheme();
  return (
    <Stack
      bgcolor={palette.EmptyPlaceholderIcons.Background}
      width={56}
      height={56}
      borderRadius={'50%'}
      alignItems="center"
      justifyContent="center"
    >
      <BusinessCenterRoundedIcon
        sx={{ color: palette.EmptyPlaceholderIcons.IconFill, fontSize: 24 }}
      />
    </Stack>
  );
};

export default EmptyOpportunityImage;
